import { tokenDestinationCard } from "./TokenDestinationCard";

export const SnapchatDestinationCard = tokenDestinationCard({
  type: "snapchat",
  intro:
    "Server-side conversions to your Snap Pixel, so a blocked browser pixel stops hiding orders from Snapchat. " +
    "Both values come from Snapchat Ads Manager: open Events Manager and copy the Pixel ID of your web pixel, " +
    "then generate the token under the top-corner menu, Business Details, Conversions API Tokens. Only an " +
    "Organization Admin sees that section, and the token works only for pixels in the organization that " +
    "generated it.",
  fields: [
    {
      key: "pixelId",
      label: "Pixel ID",
      placeholder: "0d9a1b2c-3d4e-5f60-7890-abcdef123456",
      helpText: "The long ID with dashes, on your web pixel's details in Events Manager.",
    },
    {
      key: "accessToken",
      label: "Conversions API token",
      secret: true,
      helpText: "A long-lived token. Snapchat does not expire these on a schedule; deleting it in Ads Manager revokes it.",
    },
  ],
  testNote:
    "Test sends a sample purchase to Snapchat's validation endpoint, so it shows up under Test Events in Events " +
    "Manager and never counts in your reporting. Two things to know before you turn this on. Snapchat drops any " +
    "event older than seven days, so a replay after an outage only covers what fits in that window. And if you " +
    "already run Snapchat's own Shopify app or your own Snap Pixel, check what each one sends: Snapchat merges " +
    "two reports of one purchase only when both carry the same event ID, or the same order ID within 30 days.",
});
